module.exports = __webpack_public_path__ + "img/9788992036863.ff64be8c.jpg";